import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Beaker02 = function Beaker02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9 6v4.5012c0 .5509 0 .8264-.0687 1.0817a2 2 0 0 1-.2957.6314c-.1522.2162-.3638.3925-.787.7452l-3.6972 3.081c-.4232.3527-.6348.529-.787.7452a2 2 0 0 0-.2957.6314C3 17.6724 3 17.9479 3 18.4988V18.8c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C4.5198 22 5.08 22 6.2 22h11.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C21 20.4802 21 19.9201 21 18.8v-.3012c0-.5509 0-.8264-.0687-1.0817a2 2 0 0 0-.2957-.6314c-.1522-.2162-.3638-.3925-.787-.7452l-3.6972-3.081c-.4232-.3527-.6348-.529-.787-.7452a2 2 0 0 1-.2957-.6314C15 11.3276 15 11.0521 15 10.5012V6M8.3 6h7.4c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185C16.5 5.62 16.5 5.48 16.5 5.2V2.8c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C16.12 2 15.98 2 15.7 2H8.3c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C7.5 2.38 7.5 2.52 7.5 2.8v2.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185C7.88 6 8.02 6 8.3 6M5.5 17h13c.4647 0 .697 0 .8902.0384a2 2 0 0 1 1.5714 1.5714C21 18.803 21 19.0353 21 19.5s0 .697-.0384.8902a2 2 0 0 1-1.5714 1.5714C19.197 22 18.9647 22 18.5 22h-13c-.4647 0-.697 0-.8902-.0384a2 2 0 0 1-1.5714-1.5714C3 20.197 3 19.9647 3 19.5s0-.697.0384-.8902a2 2 0 0 1 1.5714-1.5714C4.803 17 5.0353 17 5.5 17"
    })
  }));
};
export default Beaker02;